import styles from "./tables.module.css"
import ArrowGreen from "../../../images/arrow-product-green-right.svg"
import { NavLink } from "react-router-dom"
import { useActiveButton } from "../../../services/context/ActiveButtonContext"

function SubButtonLinks() {
  const val = useActiveButton()
// console.log(val.availableTables[val.tabNumber].instructions.title);
  return (
    <div className={styles.buttonWrapper}>
      <NavLink to={"/info/glossarij-investora"} className={styles.subButton}>
        <div className={styles.buttonTxt}>Глоссарий инвестора</div>
        <img src={ArrowGreen} className={styles.arrowGreenImg} />
      </NavLink>
      <NavLink to={!!val.availableTables[val.tabNumber].instructions.slug && val.availableTables[val.tabNumber].instructions.slug} className={styles.subButton}>
        <div className={styles.buttonTxt}>
          {val.availableTables[val.tabNumber].instructions.title && val.availableTables[val.tabNumber].instructions.title}
        </div>
        <img src={ArrowGreen} className={styles.arrowGreenImg} />
      </NavLink>
      
    </div>
  )
}

export default SubButtonLinks
